export default __webpack_public_path__ + "static/media/mystry_plus_bg.0799f0ee.png";